// This file added by Bearer Web Developer
const getToday = () => {
    // Get the current date
    const today = new Date();
    // Extract year, month, and day
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export default getToday;